import { Component, Inject, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ReservationService } from '../../../../../reservation.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Slot, UserData } from '../../../../../reservation.model';
import { debounceTime, map, startWith } from 'rxjs';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DataBagService } from '../../../../../../common/data-bag.service';
import { ReservationSummaryApiService } from '../../../../services/reservation-summary-api.service';
import { InfoboxService } from '../../../../../../common/infobox/infobox.service';
import { LoaderService } from '../../../../../../common/loader/loader.service';
import { TypeValueFactoryService } from '../../../../../../common/type-value-factory.service';
import { ReservationAccomodationOfferParticipantDialogComponent } from '../reservation-accomodation-offer-participant-dialog/reservation-accomodation-offer-participant-dialog.component';

@Component({
	selector: 'app-reservation-summary-acommodation-offer-participant-change-dialog',
	templateUrl: './reservation-summary-acommodation-offer-participant-change-dialog.component.html',
	styleUrls: ['./reservation-summary-acommodation-offer-participant-change-dialog.component.scss'],
})
export class ReservationSummaryAcommodationOfferParticipantChangeDialogComponent implements OnInit {
	constructor(
		private readonly _service: ReservationService,
		private readonly dialogRef: MatDialogRef<ReservationSummaryAcommodationOfferParticipantChangeDialogComponent>,
		private readonly api: DataBagService,
		private readonly apiService: ReservationSummaryApiService,
		private readonly infobox: InfoboxService,
		private readonly loader: LoaderService,
		@Inject(MAT_DIALOG_DATA) protected data: Slot,
		private readonly dialog: MatDialog,
	) {}

	protected usersSelect = new FormControl(this._service.users);

	filteredUsers: UserData[];
	selectedUser: number = null;

	ngOnInit(): void {
		this.filteredUsers = this._service.users;

		this.usersSelect.valueChanges
			.pipe(
				startWith(''),
				debounceTime(400),
				map((value) => this._filterUsers(value || '')),
			)
			.subscribe((filtered) => {
				this.filteredUsers = filtered;
			});
	}

	protected displayUsersFn(user: UserData | number): string {
		if (!(user instanceof Array) && typeof user !== 'number') return `${user.firstName} ${user.lastName}`;
		return user && typeof user === 'number'
			? `${this._service.users.find((v) => v.id === user).firstName} ${
					this._service.users.find((v) => v.id === user).lastName
				}`
			: '';
	}

	private _filterUsers(value: any): UserData[] {
		if (value && typeof value === 'string') {
			if (value.length < 3) return this._service.users;
			this.api.get(`/profile/data_full/?full_name=${value}`, (result, error) => {
				if (result) this.filteredUsers = result.results;
				else this.filteredUsers = this._service.users;
			});
			return;
		}
		return this._service.users;
	}

	selectUser($event: MatAutocompleteSelectedEvent) {
		this.selectedUser = $event.option.value.id;
	}

	closeDialog(): void {
		this.dialogRef.close();
	}

	submit(): void {
		this.loader.show('change-participant');
		this.apiService
			.actions()
			.assignUserDataToSlot(this.data.id, this.selectedUser)
			.then(() => {
				this.infobox.success('Pomyślnie zmieniono uczestnika');
			})
			.finally(() => {
				this.closeDialog();
				this.loader.hide('change-participant');
				this.apiService.actions().getReservation(this._service.reservation$.getValue().id);
			});
	}

	protected openParticipantDialog(slot: Slot) {
		this.closeDialog();
		const emptyUserData: UserData = {
			...TypeValueFactoryService.createUserDataObject(),
			userContacts: [TypeValueFactoryService.createUserContactObject()],
		};

		this.dialog.open(ReservationAccomodationOfferParticipantDialogComponent, {
			data: { ...slot, userData: emptyUserData },
		});
	}
}
